/**
 * 發包單的預設注意事項。
 *
 * 外包與內包的規範不同，所以依發包類型各有一份。發包單上的「注意事項」
 * 欄位留白時就印這裡的內容——既有單據不必逐張補資料，改版時也只要動這裡。
 *
 * 存進資料庫的是純文字（含換行），列印時以 pre-wrap 呈現，
 * 條號直接寫在文字裡，使用者增刪條款時自己調整編號即可。
 */

export const DEFAULT_TERMS: Record<string, string> = {
  外包: [
    '1. 承包人員有義務履行與發包方共同簽訂之《文案撰寫外包合作備忘錄》，本單為該備忘錄之個案附件。',
    '2. 承包人員應於收到本單後 3 個工作日內回簽確認；逾期未確認視為未接單。',
    '3. 本單所列之文章主題、關鍵字與參考資料屬客戶機密，不得外流或用於其他用途。',
    '4. 交稿後由發包方依本單所附之案件細節說明驗收，驗收結果與退件紀錄另載於對應之驗收單。',
  ].join('\n'),

  內包: [
    '1. 內部發包案件不得於上班時間及加班期間執行，惟因案件需求所需之必要溝通與協調工作不在此限，例如與業務確認或討論文章主題等。',
    '2. 內部發包案件之工作內容包含但不限於：主題評估、大綱製作、文案撰寫及內容上架等相關作業。',
    '3. 如經查核發現寫手於上班時間執行上述內部發包工作事項，該案件費用將扣除 50% 作為違規處理。',
  ].join('\n'),
}

/** 該發包類型的預設條款；認不得的類型一律給外包版 */
export function defaultTerms(dispatchType: string | null | undefined): string {
  return DEFAULT_TERMS[dispatchType ?? ''] ?? DEFAULT_TERMS['外包']
}

/** 目前內容是不是還停在某一種預設條款（沒被手動改過） */
export function isDefaultTerms(text: string): boolean {
  const t = text.trim()
  return t === '' || Object.values(DEFAULT_TERMS).some((d) => d.trim() === t)
}
